<template>
	<div id="page-user-edit">
		<bread-crumbs
			v-if="activeTab === 0"
			:title="$t('CompanyConfigCrud')"
			:subTitle="$t('general.SubtitleConfigCompany')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<div :class="activeTab === 0 ? 'vx-card p-4' : ''">
			<div v-if="activeTab === 0" class="tab-text">
				<company-config-crud-list-view
					:data="companyData"
					@selectedCompanyEmit="selectedCompanyEmit"
					@valueFormConfigCompany="valueFormConfigCompanyEmit"
				/>
			</div>
			<div v-else-if="activeTab === 1" class="tab-text">
				<template v-if="activeTab === 1">
					<bread-crumbs
						class="ml-1"
						:title="
							company.id > 0
								? $t('Crud.Update') + ' ' + $t('CompanyConfigCrud')
								: $t('general.New2') + ' ' + $t('CompanyConfigCrud')
						"
						:subTitle="
							company.id > 0
								? $t('CompanyConfigCrudFormTitleEdit')
								: $t('CompanyConfigCrudFormTitleCreate')
						"
						:sizeTitle="22"
						:lineHeightTitle="27"
						:sizeSubTitle="13"
						:lineHeightSubTitle="16"
					>
					</bread-crumbs>
					<div class="vx-row">
						<div class="vx-col w-full flex items-center">
							<feather-icon
								class="g-breadcrumb--title"
								icon="ChevronLeftIcon"
								svgClasses="h-8 w-8"
								@click.prevent="valueFormConfigCompanyEmit(0)"
							/>
							<vs-breadcrumb
								class="g-breadcrumb--title"
								separator=""
								:items="[{title: $t('general.Return')}]"
								@click.prevent="valueFormConfigCompanyEmit(0)"
							></vs-breadcrumb>
						</div>
					</div>
				</template>
				<company-config-crud-form
					:data="company"
					@changeActiveTabEmit="changeActiveTab"
					@updateCompanyConfigEmit="updateCompanyConfigList"
					@valueFormConfigCompany="valueFormConfigCompanyEmit"
				/>
			</div>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import CompanyConf from "@/models/CompanyConf.js";
import CompanyConfigCrudForm from "./CompanyConfigCrudForm.vue";
import CompanyConfigCrudListView from "./CompanyConfigCrudListView.vue";
import moduleCompanyConfigCrud from "@/store/company-config-crud/moduleCompanyConfigCrud.js";

export default {
	name: "CompanyConfigCrud",
	data() {
		return {
			company: new CompanyConf(0, {}),
			companyData: {},
			activeTab: 0,
			isEditActive: false,
		};
	},
	components: {
		CompanyConfigCrudForm,
		CompanyConfigCrudListView,
	},
	methods: {
		valueFormConfigCompanyEmit(val) {
			this.activeTab = val;
			if (this.activeTab === 0) {
				this.company = new CompanyConf(0, {});
			}
		},
		// Se activa al seleccionar editar en ListView
		selectedCompanyEmit(company) {
			this.company = company;
			this.activeTab = 1;
		},
		// Se utiliza para cambiar la pestaña actual y limpiar la compañia
		changeActiveTab(tabNum) {
			this.activeTab = tabNum;
			this.company = new CompanyConf(0, {});
		},
		loading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		consultCompanyConfig() {
			this.loading();
			// Consulta las configuraciones de compañias existentes
			this.$store
				.dispatch("moduleCompanyConfigCrud/fetchDataListItems")
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		fetchConfigCompanyById() {
			this.loading();
			// Consulta las configuraciones de compañias existentes
			this.$store
				.dispatch("moduleCompanyConfigCrud/fetchConfigCompanyById", this.$route.params.company_id)
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		updateCompanyConfigList() {
			if (this.$route.params.company_id) {
				this.fetchConfigCompanyById();
			} else {
				this.consultCompanyConfig();
			}
		},
	},
	created() {
		// Registra el modulo
		if (!moduleCompanyConfigCrud.isRegistered) {
			this.$store.registerModule("moduleCompanyConfigCrud", moduleCompanyConfigCrud);
			moduleCompanyConfigCrud.isRegistered = true;
		}
		if (this.$route.params.company_id) {
			this.fetchConfigCompanyById();
			this.activeTab = 1;
		} else {
			this.consultCompanyConfig();
		}
	},
};
</script>
